import { PerformanceStatusEnum } from '@/types/schema';

import { Content, ContentPerformanceStatusEnum } from '../types';

const getStatus = (content: Content) => {
  if (!content.performance || content.performance.status === PerformanceStatusEnum.NotStarted) {
    return ContentPerformanceStatusEnum.NotStarted;
  }

  if (content.performance.status === PerformanceStatusEnum.Completed) {
    return ContentPerformanceStatusEnum.Completed;
  }

  return ContentPerformanceStatusEnum.InProgress;
};

export default getStatus;
